module.exports = __webpack_public_path__ + "assets/img/3-whos-this-for-min.930fbd5d.jpg";